<template>
  <div class='SelectCategory'>
    <div class="select">
      <input-select
      :data="Categorias"
      @update:modelValue="newValue => SelectCategory(newValue)"
      :cont="{ flex: '1' }"
      :label="{ display: 'none' }"
      :input="{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <div class="cont-btn">
        <button @click="PushCategory">adicionar</button>
      </div>
    </div>
    <div class="cont">
      <category-list
      v-for="(c, key) in Categorys"
      :key="key"
      :data="c"
      @del="data => DelCategory(data)"
      @updateimg="newValue => c.img = newValue"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputSelect from '../Produtos/Register/InputSelect'
import CategoryList from './CategoryList'
export default {
  name: 'SelectCategory',
  components: { InputSelect, CategoryList },
  data () {
    return {
      SelectedCategory: {},
      Categorys: []
    }
  },
  computed: {
    ...mapGetters(['Categorias'])
  },
  methods: {
    ...mapActions(['GetCategory', '_CreateFrenteLojaCategoria', '_DeleteFrenteLojaCategoria', 'GetFrenteLojaCategoria']),
    SelectCategory (name) {
      this.SelectedCategory = this.Categorias.filter(c => c.name === name)[0]
    },
    PushCategory () {
      this._CreateFrenteLojaCategoria({ nome: this.SelectedCategory.name, img: '', categid: this.SelectedCategory.id })
        .then(res => {
          this.Categorys.push(res)
        })
    },
    DelCategory (data) {
      this._DeleteFrenteLojaCategoria({ id: data.id, img: data.img })
        .then(() => {
          this.Categorys = this.Categorys.filter(c => c.id !== data.id )
        })
    }
  },
  created () {
    this.GetCategory()
      .then(() => this.GetFrenteLojaCategoria())
      .then(res => {
        this.Categorys = res
      })
  }
}
</script>

<style scoped>
.select {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cont-btn {
  width: 150px;
  display: flex;
  justify-content: flex-end;
}

button {
  color: #FFFFFF;
  padding: 8px 16px;
  font-size: 14px;
  background-color: #000000;
  border: 0;
  border-radius: 5px;
  cursor: pointer;
}

</style>
